import { Box } from "@tokenterminal/ui/Box"
import { projectLogoSkeleton } from "./ProjectLogo.css"

interface Props {
  size?: number | `${number}`
  className?: string
}

export const ProjectLogoSkeleton = ({ size = "40", className }: Props) => (
  <Box
    role="presentation"
    style={{ width: size, height: size }}
    background="secondary"
    borderRadius="rounded"
    className={[projectLogoSkeleton, className]}
  />
)
